module.exports = __webpack_public_path__ + "img/Солтүстік Қазақстан облысы.c0816dd2.png";